<template>
  <div class="home-container">
    <div class="bg-img-title pc animate__animated animate__fadeInRight">
      <p>{{ $t('lang.homeText') }}</p>
      <p style="" class="homeText-left">{{ $t('lang.homeText1') }}</p>
    </div>
    <div class="bg-img-title phone animate__animated animate__fadeInRight">
      <span>{{ $t('lang.homeText') + '—' + $t('lang.homeText1') }}</span>
    </div>
    <div class="nesc_a1t_bg animate__animated animate__fadeIn">
      <img src="../assets/image/home.jpeg?v=2" style="width: 100%;">
      <ul class="mc_pos_cover" :class="{show: coverShow}">
        <li v-for="(item, index) in targetList" :key="index" class="mc_a1t_li" :style="{'left': `calc(`+item.left+` - 32px)`, 'top': `calc(`+item.top+` - 32px)`}">
          <span class="mc_a1t_li_dian" />
          <router-link class="mc_a1t_xl flex-row-left" :to="item.url">
            <span class="mc_a1t_title">{{ index > 0 ? $t('lang.' + item.title) + $t('lang.solutionTxt') : $t('lang.' + item.title) }}</span>
            <span class="mc_a1t_jiantou">
              <i class="el-icon-arrow-right" />
            </span>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- 首页新闻 -->
    <div v-loading="loading" class="fp-tableCell">
      <div class="content2">
        <div class="mc_a1s1_wrap">
          <div class="news-hd flex-row-between">
            <h3 class="news-hd-title">{{ $t('lang.newsTitle') }}</h3>
            <router-link to="/about/news" class="flex-row-left checkMore">
              <span style="font-size: 14px;font-weight: bold;color: #666666">{{ $t('lang.checkMore') }}</span>
              <i class="icon-nextstep" />
            </router-link>
          </div>
          <div class="news-hd-bd">
            <ul class="flex-row-left" style="flex-flow: wrap">
              <li v-for="item in newsList" :key="item.NewsInfoId" class="news-bd-li">
                <router-link :to="{ name: 'newsDetail', params: { id: item.NewsInfoId, time: item.CreateTime }}">
                  <div class="news-bd-li-link">
                    <div class="news-bd-link-txtbox">
                      <div class="n_nesc3date">{{ item.CreateTime }}</div>
                      <div class="n_nesc3txt">{{ item.Title }}</div>
                      <div class="n_nesc3more"><div class="n_nesc3more_morebtn">了解更多</div></div>
                    </div>
                    <div class="news-bd-imgbox">
                      <img class="news_list_png" :src="require('../assets/image/empty.png')">
                      <img class="news_list_img" :src="imgServer + item.CoverImage" alt="guanwang.jpg">
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: () => {
    return {
      targetList: [
        { title: 'companyProfile', left: '45.93%', top: '33.65%', img: '', url: '/aboutUs/companyProfile' },
        { title: 'shippingIndustrySolution', left: '25.89%', top: '69.93%', img: '', url: '/industrySolutions/shippingIndustrySolution' },
        { title: 'deliveryIndustrySolution', left: '64.67%', top: '68.19%', img: '', url: '/industrySolutions/deliveryIndustrySolution' },
        { title: 'policeIndustrySolution', left: '43.67%', top: '88.56%', img: '', url: '/industrySolutions/policeIndustrySolution' },
        { title: 'parkIndustrySolution', top: '77.35%', left: '83.07%', img: '', url: '/industrySolutions/parkIndustrySolution' }
      ],
      newsList: [],
      loading: !0,
      coverShow: !1
    }
  },

  mounted() {
    this.imgServer = this.domainUrl
    setTimeout(() => {
      this.coverShow = !0
    }, 50)
    this.$http.post(this.isDevelop ? '/NewsList' : '/api/NewsService/NewsList', { page: 1, limit: 3 }).then(
      (responseNews) => {
        responseNews.statusText == 'OK' && responseNews.data.data.length > 0 && (
          this.newsList = responseNews.data.data || [],
          this.loading = !1
        )
      }
    ).catch(function() {
      this.newsList = []
    })
  },

  methods: {
    gotoPage(path) {
      window.href = path
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/home';
</style>
